/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  REQUEST_PERMISSION_SUCCESS,
  REQUEST_PERMISSION_FAILURE,
} from "../actions/actionTypes";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case REQUEST_PERMISSION_SUCCESS:
      return {
        permissionRequestSuccess: true,
      };
    case REQUEST_PERMISSION_FAILURE:
      return {
        permissionRequestSuccess: false,
        message: action.err.message,
      };
    default:
      return state;
  }
}
